import React, { useMemo } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { IdCard } from "lucide-react";

import DashboardLayout from "src/components/layout/dashboard/Layout";
import TenantUserForm from "src/components/forms/TenantUserForm";

import { useAppSelector } from "src/redux/hooks";

const CreateEditUserPage: React.FC = () => {
  const basePath = "/app/team-management";
  const navigate = useNavigate();
  const { tenantUserId } = useParams();
  const {
    user: { data: user },
  } = useAppSelector((state) => state.authTenant);

  const permissions = useMemo(
    () => user?.roleDetails?.permissions || user?.permissions || {},
    [user?.roleDetails?.permissions, user?.permissions]
  );
  const permissionEntries = Object.keys(permissions || {});
  const isTenantAdmin =
    user?.role === "admin" ||
    user?.roleDetails?.name?.toLowerCase() === "admin";
  const canAccessTeamManagement =
    isTenantAdmin ||
    permissionEntries.length === 0 ||
    (permissions?.users || []).includes("view");

  if (!canAccessTeamManagement) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <DashboardLayout
      meta={{
        title: `${tenantUserId ? "Edit" : "Add"} Staff | Invyntra`,
        description: "Manage staff for your workspace.",
      }}
    >
      <div className="space-y-4">
        <div className="flex items-start gap-4">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 dark:bg-primary-900/40 dark:text-primary-300">
            <IdCard size={26} />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
              {tenantUserId ? "Edit Staff" : "Add Staff"}
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Employee records and optional login accounts.
            </p>
          </div>
        </div>

        <TenantUserForm
          tenantUserId={tenantUserId}
          onCancel={() => navigate(`${basePath}/user-list`)}
          onSuccess={() => navigate(`${basePath}/user-list`)}
        />
      </div>
    </DashboardLayout>
  );
};

export default CreateEditUserPage;
